<template>
	<div class="inner-page upload-images">

		<div v-if="thisCase.status != 'archive'">

			<Placeholder
				v-if="actualProgressStage == 5"
				message="You can no longer view this stage."
				:withBackButton="true"
				/>

			<template v-else>
			
				<AppHead title="Upload Case Images" />

				<PageHeader 
					title="Upload Case Images"
					desc="Provide the required files to process your case"
					:hasButton="false"
					:showHelper="true"
					helpTitle="Uploading Case Images"
					helpDesc="You can progress your case further by supplying the relevant imagery whilst we review your enquiry."
					/>

				<CaseProgressBar 
					:step="thisCase.progress_stage" 
					:thisCase="thisCase"
					:pageStep="1"
					/>

				<div class="upload-images-form">
					
					<InputGroup
						title="Please upload CT scans and X-rays"
						:desc='`OrthoMatrix CT Instructions are available in the <a href="/doc-library" target="_blank">Document Library</a>`'
						>
						<UploadBox 
							:case="thisCase" 
							designation="image"
							@done="uploadingFinished"
							:maxFiles="30"
							/>
					</InputGroup>

					<div 
						class="existing-images"
						v-if="imageUploads && imageUploads.length > 0"
						>

						<InputGroup
							title="Existing Image Files"
							desc='These images have already been uploaded to the case. If you need to upload more, please do so above.'
							>

							<div class="file-list" v-if="imageUploads.length > 0">
								<FileBox
									v-for="(imageFile, index) in imageUploads"
									:key="index"
									:file="imageFile"
									:canDownload="true"
									/>
							</div>

						</InputGroup>

					</div>


					<InputGroup
						title=""
						desc=""
						:skipWhiteBox="true"
						:noLine="true"
						:flexInputBlock="true"
						:oneColumn="true"
						class="button-group"
						>
						<Button
							label="Next"
							color="green"
							size="large"
							icon="save" 
							@click="submit"
							:disabled="!isFormComplete"
							/>
						<Button
							label="Back"
							color="white"
							size="large"
							icon="times"
							push="left"
							:buttonRoute="`/cases/${thisCase.hashid}`"
							/>
					</InputGroup>

				</div>

			</template>

		</div>
    <Placeholder
      v-else
      message="This case has been archived. You can no longer edit it."
			:withBackButton="true"
      />


	</div>
</template>

<script>

import AppLayout from "@/Layouts/AppLayout.vue"
import AppHead from "@/Components/AppHead"
import PageHeader from "@/Components/PageHeader"
import Button from "@/Components/Button"
import ButtonDownload from "@/Components/ButtonDownload"
import InputGroup from "@/Components/InputGroup"
import CaseProgressBar from "@/Components/Cases/CaseProgressBar"
import UploadBox from "@/Components/Upload/UploadBox"
import InputTextarea from "@/Components/InputTextarea"
import Placeholder from "@/Components/Placeholder"
import Subtitle from "@/Components/Subtitle"
import FileBox from "@/Components/Cases/FileBox"

export default {
	props: [
		'thisCase',
		'imageUploads'
	],
	components: {
		AppLayout,
		AppHead,
		PageHeader,
		Button,
		ButtonDownload,
		InputGroup,
		CaseProgressBar,
		UploadBox,
		InputTextarea,
		Placeholder,
		Subtitle,
		FileBox
	},
	layout: AppLayout,
	data: () => {
		return {
			isFormComplete: false
		}
	},
	mounted(){
		// console.log('images', this.imageUploads)
	},
	methods: {
		submit(){
			if(this.isFormComplete){
				this.$inertia.post(`/cases/${this.thisCase.hashid}/image-submission`)
			}
		},
		uploadingFinished(){
			this.isFormComplete = true
		}
	},
	computed: {
		actualProgressStage(){
			if(this.thisCase.override_progress !== null){
				return this.thisCase.override_progress
			}else{
				return this.thisCase.progress_stage
			}
		}
	}
};

</script>

<style lang="sass">

.upload-images
	.upload-images-form
		padding-top: 30px

	.existing-images
		margin-bottom: 40px
		
		.file-list
			margin-bottom: 30px
			width: 100%
			display: flex
			flex-direction: column
			gap: 10px

	.button-group
		.input-block
			@media (max-width: 768px)
				display: flex
				flex-direction: column
				gap: 10px

				.button
					margin: 0
					width: 100%

				a
					display: flex
					width: 100%

</style>